import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MyQuestionCss } from "../../styles/myQuestion";
import { ActionButton } from "../../styles/communityCommon";
import Question from "./question";
import { GET_ALL_QUESTIONS } from "../../api";
import { useCookies } from "react-cookie";

const MyQuestions = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [cookies, setCookie] = useCookies(["authToken"]);

  const [myques, setMyQues] = useState([]);

  useEffect(() => {
    GET_ALL_QUESTIONS()
      .then((res) => {
        console.log("ALL Questions::", res);

        let ques = res.data;

        let myQues = [];

        for (let i = 0; i < ques.length; i++) {
          if (ques[i].createdByID == cookies.userID) {
            let obj = {
              id: ques[i].id,
              content: ques[i].question,
            };

            console.log("INSIDE!!!!");

            myQues.push(obj);
          }
        }

        console.log("My Questions:::::", myQues);

        setMyQues(myQues);
      })
      .catch((er) => {
        console.log("Error while getting question:", er);
      });
  }, []);

  return (
    <>
      <MyQuestionCss />
      <div className="myquestion-container">
        {myques.map((e) => {
          return <Question question={e} />;
        })}
      </div>
    </>
  );
};

export default MyQuestions;
